import { render, staticRenderFns } from "./InfoMessage.vue?vue&type=template&id=56b8500b&scoped=true&"
import script from "./InfoMessage.vue?vue&type=script&lang=js&"
export * from "./InfoMessage.vue?vue&type=script&lang=js&"
import style0 from "./InfoMessage.vue?vue&type=style&index=0&id=56b8500b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b8500b",
  null
  
)

export default component.exports